import { createDeck } from '../store';

/**
 * Naming a new deck is the same one-field question from the sidebar and from
 * the Decks page, so the verb lives here rather than being retyped per surface.
 */
export const promptForNewDeck = (t) => {
  const name = prompt(t('sidebar:deckNamePlaceholder'), t('sidebar:defaultDeckName'));
  if (name?.trim()) createDeck(name.trim());
};
